import { Group } from '@/components/_common';
import { PortoPolicyVoucherItem } from '@/core/domain/porto/policies/porto-policies.types';
import { Card, Empty, Skeleton, Typography } from 'antd';
import moment from 'moment';

interface Props {
  vouchers: PortoPolicyVoucherItem[];
  isLoading: boolean;
}

export default function PortoVoucherList({ isLoading, vouchers }: Props) {
  return (
    <div>
      <Typography.Title level={4} style={{ marginTop: 16 }}>
        Vouchers do cliente
      </Typography.Title>

      <Skeleton loading={isLoading}>
        {!vouchers.length && (
          <Empty description="Não há vouchers para este CPF" />
        )}

        <div style={{ maxHeight: 300, overflowY: 'auto' }}>
          {vouchers.map((voucher) => (
            <Card
              style={{ marginBottom: 16, borderRadius: 8 }}
              bodyStyle={{ padding: 16 }}
            >
              <strong style={{ display: 'block', fontSize: '1.05rem' }}>
                {voucher.name}
              </strong>

              <Group gap={24}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span style={{ fontSize: '0.8rem', color: 'darkgray' }}>
                    Cód. Serviço
                  </span>
                  <span>{voucher.serviceCode}</span>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span style={{ fontSize: '0.8rem', color: 'darkgray' }}>
                    Última utilização
                  </span>
                  <span>
                    {voucher.wasUsedIn
                      ? moment(voucher.wasUsedIn).format('DD/MM/YYYY')
                      : 'Sem utilização'}
                  </span>
                </div>
              </Group>
            </Card>
          ))}
        </div>
      </Skeleton>
    </div>
  );
}
